<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">
              <div class="row mt-2">

                <div class="form-group mb-2 me-2 col-md-4 col-lg-4 col-xl-4">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="statuses"
                                   class="multiselect-sm"
                                   v-model="requestDTO.statuses"
                                   :options="Object.values(DepositStatus)"
                                   :custom-label="(opt) => helper.trans(`deposit_status.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.status')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-5 col-lg-5 col-xl-5">
                  <div class="d-flex align-items-center gap-1">
                    <label class="col-form-label text-capitalize-first p-0 me-1">{{ helper.trans("labels.owner") }}:</label>
                    <button type="button" class="btn btn-sm btn-outline-dark text-capitalize-first"  @click.prevent="toggleType()">{{ accountType ? helper.trans(`labels.${accountType}`) : helper.trans(`labels.select`)  }}</button>
                    <div class="w-100" v-if="accountType && accountType !== 'system'">
                      <Multiselect
                        class="multiselect-sm"
                        v-model="requestDTO.account"
                        :options="accounts"
                        :custom-label="(opt) => labelFor(accountType!, opt)"
                        track-by="id"
                        select-label="Select"
                        open-direction="bottom"
                        :multiple="false"
                        :searchable="true"
                        :loading="isLoading"
                        :internal-search="false"
                        :clear-on-select="true"
                        :close-on-select="true"
                        :options-limit="100"
                        :limit="1000"
                        :show-no-results="false"
                        :hide-selected="false"
                        @search-change="asyncFindAccounts"
                      >
                      </Multiselect>
                    </div>
                    <button v-if="accountType" type="button" class="btn btn-sm btn-link" @click.prevent="clearType()"><i class="fa fa-times"></i></button>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button v-if="isAdmin" type="button" @click.prevent="() => { searchDepositModal?.show(); }" class="btn btn-outline-info btn-sm rounded-pill me-2 text-capitalize-first">
                      <i class="fa fa-search me-1"></i>{{ helper.trans('button.search_deposits') }}
                    </button>
                    <button type="button" @click.prevent="() => exportData()" class="btn btn-outline-success btn-sm rounded-pill me-2 text-capitalize-first">
                      <i class="fa fa-download me-1"></i>{{ helper.trans('button.export') }}
                    </button>
                    <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="card card-body">
              <div class="overflow-auto">
                <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                  <thead>
                  <tr>
                    <th class="text-capitalize-first">{{ helper.trans('labels.id') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans("labels.owner") }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.status') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.sum') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.from_address.usdt') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.tx_id') }}</th>
                    <th v-if="isAdmin || isOperator" class="text-capitalize-first">{{ helper.trans('labels.aml_result') }}</th>
                    <th class="text-end">
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="deposit in response.items" :key="deposit.id" class="">
                    <td>
                      <div class="d-flex flex-column mt-1 mb-1">
                        <span>
                          <span v-b-tooltip.hover :title="deposit.id">{{ deposit.id.substring(0, 8) }}...</span> <copy-button :value="deposit.id"></copy-button>
                        </span>
                        <small class="text-secondary">{{ dateHelper.format(deposit.createdAt) }}</small>
                      </div>
                    </td>
                    <td>
                      <UserNameLabel v-if="deposit._traderAccount" show-badge :user="deposit._traderAccount.user"></UserNameLabel>
                      <UserNameLabel v-if="deposit._userAccount" show-badge :user="deposit._userAccount.user"></UserNameLabel>
                      <div v-if="deposit._merchantStoreAccount" class="d-flex flex-row align-items-center">
                        <div>
                          <UserNameLabel show-badge :user="deposit._merchantStoreAccount.user"></UserNameLabel>
                          <div class="d-flex" style="clear: both">{{deposit._merchantStoreAccount?.storeName }}</div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div>
                        {{ helper.trans(`deposit_status.${deposit.status}`) }}
                        <i class="fa fa-spin fa-spinner text-primary" v-if="deposit.status === DepositStatus.NEW || deposit.status === DepositStatus.RETURN_IN_PROGRESS"></i>
                        <i class="fa fa-rotate-left text-warning" v-if="deposit.status === DepositStatus.RETURNED"></i>
                        <i class="fa fa-warning text-warning" v-if="deposit.status === DepositStatus.REJECTED"></i>
                      </div>
                      <small class="text-secondary">{{ dateHelper.format(deposit.updatedAt) }}</small>
                    </td>
                    <td>
                      {{ numberFormatter.formatMoney(deposit.sum, 2) }}
                      <div v-if="deposit.sum.currency !== deposit.creditedSum.currency">
                        <small class="text-secondary">
                          {{ numberFormatter.formatMoney(deposit.creditedSum, 2) }}
                        </small>
                      </div>
                    </td>
                    <td>{{ deposit.fromAddress }}</td>
                    <td>
                      <div>
                        {{ deposit.txId.substring(0, 16) }}...
                        <copy-button :value="deposit.txId"></copy-button>
                        <a :href="`https://tronscan.org/#/transaction/${deposit.txId}`" target="_blank" class="ms-2">
                          <i class="fa fa-external-link"></i>
                        </a>
                      </div>
                      <div v-if="deposit.returnedTxId">
                        {{ deposit.returnedTxId!.substring(0, 16) }}...
                        <copy-button :value="deposit.returnedTxId"></copy-button>
                        <a :href="`https://tronscan.org/#/transaction/${deposit.returnedTxId}`" target="_blank" class="ms-2">
                          <i class="fa fa-external-link"></i>
                        </a>
                      </div>
                    </td>
                    <td v-if="isAdmin || isOperator">
                      <div v-if="deposit.amlResult">
                        <i v-if="deposit.amlResult.riskScore.risky" class="text-danger fa fa-warning"></i>
                        <i v-else class="text-success fa fa-check"></i>
                        <small class="ms-1"><strong>{{numberFormatter.formatNumber(parseFloat(deposit.amlResult!.riskScore.total) * 100, 2)}}%</strong></small>
                        <small class="ms-1">l: {{numberFormatter.formatNumber(parseFloat(deposit.amlResult!.riskScore.low) * 100, 2)}}%</small>
                        <small class="ms-1">m: {{numberFormatter.formatNumber(parseFloat(deposit.amlResult!.riskScore.medium) * 100, 2)}}%</small>
                        <small class="ms-1">h: {{numberFormatter.formatNumber(parseFloat(deposit.amlResult!.riskScore.high) * 100, 2)}}%</small>
                      </div>
                    </td>
                    <td class="text-end">
                      <button v-if="(isAdmin || (isOperator && store.getters.hasPermission(UserPermission.ACCEPT_AML_REJECTED_DEPOSITS))) && (deposit.status === DepositStatus.REJECTED || deposit.canRecheckAml)" type="button" @click="processDeposit(deposit)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2">{{helper.trans('button.process_deposit')}}</button>
                      <button v-if="isAdmin && deposit.status === DepositStatus.REJECTED" type="button" @click="returnDeposit(deposit)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2">{{helper.trans('button.return_deposit')}}</button>
                      <button
                          v-if="isAdmin && deposit.canRecheckAml"
                          @click="renewAmlDepositCheck(deposit)"
                          type="button"
                          class="btn btn-sm btn-outline-danger text-nowrap text-capitalize-first"
                      >
                        {{helper.trans('button.recheck_aml')}}
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <b-pagination
                  v-if="response.totalCount > response.items.length"
                  v-model="page"
                  :total-rows="response.totalCount"
                  :per-page="response.limit"
                  :limit="20"
                  @update:modelValue="load()"
                  prev-text="Back"
                  next-text="Next"
                  align="start"
                  first-number
                  hide-goto-end-buttons
                  hide-ellipsis
                ></b-pagination>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <ConfirmModal ref="confirmModal"></ConfirmModal>
    
    <SearchDepositModal ref="searchDepositModal" @deposit:credited="load"></SearchDepositModal>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {computed, defineComponent, onMounted, reactive, ref, toRefs} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import {deposits} from "@/service/api/deposits";
import {useStore} from "vuex";
import {debounce, helper} from "@/service/CommonHelper";
import ConfirmModal, {ConfirmModalProps} from "@/components/ConfirmModal.vue";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import {UserRole} from "@/models/enum/UserRole";
import {UserPermission} from "@/models/enum/UserPermission";
import Multiselect from "vue-multiselect";
import {DepositStatus} from "@/models/enum/DepositStatus";
import DepositDTO from "@/models/DepositDTO";
import PaginationDTO from "@/models/PaginationDTO";
import UserAccountDTO from "@/models/UserAccountDTO";
import MerchantStoreAccountDTO from "@/models/MerchantStoreAccountDTO";
import TraderAccountDTO from "@/models/TraderAccountDTO";
import UserNameLabel from "@/components/UserNameLabel.vue";
import SearchDepositModal from "@/components/SearchDepositModal.vue";
import MerchantDTO from "@/models/MerchantDTO";

const api = new APIClient();
const notification = useNotification()
const defaultRequestDTO = {
  statuses: [DepositStatus.NEW, DepositStatus.REJECTED, DepositStatus.RETURN_IN_PROGRESS],
  accountId: null,
  merchantId: null,
}
const types = [null, 'trader', 'teamlead', 'referral', 'store', 'merchant'];

export default defineComponent({
  components: {
    UserNameLabel,
    Multiselect,
    LoaderWrapper,
    ConfirmModal,
    CopyButton,
    BPagination,
    SearchDepositModal,
  },
  setup() {
    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const confirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null)
    const searchDepositModal = ref<InstanceType<typeof SearchDepositModal> | null>(null)

    const state = reactive({
      page: 1,
      isLoading: false as boolean,
      accountType: null as string|null,
      accounts: [] as TraderAccountDTO[]|MerchantStoreAccountDTO[]|UserAccountDTO[]|MerchantDTO[],
      requestDTO: {...defaultRequestDTO} as any,
      response: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<DepositDTO>
    });

    const load = async () => {
      state.response.offset = state.response.limit * (state.page - 1)
      loader.value?.show()
      const request: any = {
        statuses: state.requestDTO.statuses,
        accountId: state.accountType !== 'merchant' ? (state.requestDTO.account ? state.requestDTO.account.id : state.requestDTO.accountId) : null,
      }

      if (state.accountType === 'merchant' && state.requestDTO.account) {
        request.merchantId = state.requestDTO.account.id
      } else if (state.requestDTO.merchantId) {
        request.merchantId = state.requestDTO.merchantId
      }

      state.response = await api.call.deposits.list(state.response, request)
      const accountIds = state.response.items.map((item) => item.accountId);

      let userAccounts = {} as UserAccountDTO[]|any;
      let storeAccounts = {} as MerchantStoreAccountDTO[]|any;
      let traderAccounts = {} as TraderAccountDTO[]|any;

      if (accountIds.length > 0) {
        for (const account of (await api.traderAccounts({offset:0, limit: 1000} as PaginationDTO, {ids: accountIds})).items) {
          traderAccounts[account.account.id] = account
        }
        for (const account of (await api.merchantStoreAccounts({offset:0, limit: 1000} as PaginationDTO, {ids: accountIds})).items) {
          storeAccounts[account.account.id] = account
        }
        for (const account of (await api.userAccounts({offset:0, limit: 1000} as PaginationDTO, {ids: accountIds})).items) {
          userAccounts[account.account.id] = account
        }
      }

      for (const item of state.response.items) {
        item._traderAccount = traderAccounts[item.accountId] ?? null;
        item._merchantStoreAccount = storeAccounts[item.accountId] ?? null;
        item._userAccount = userAccounts[item.accountId] ?? null;
      }


      loader.value?.hide()
    }


    const applyFilters = async () => {
      state.page = 1;
      load()
    }

    const clearFilters = async () => {
      state.page = 1;
      state.requestDTO = {...defaultRequestDTO}
      load()
    }

    const returnDeposit = (deposit:DepositDTO) => {
      confirmModal.value?.show({
        title: helper.trans('labels.return_deposit_confirm'),
        okTitle: null,
        cancelTitle: null,
        onOkClick: async () => {
          try {
            await api.call.deposits.return(deposit.id);
            load()
          } finally {
          }
        }
      } as ConfirmModalProps);
    }

    const processDeposit = (deposit:DepositDTO) => {
      confirmModal.value?.show({
        title: helper.trans('labels.process_deposit_confirm'),
        okTitle: null,
        cancelTitle: null,
        onOkClick: async () => {
          try {
            await api.call.deposits.process(deposit.id);
            load()
          } finally {
          }
        }
      } as ConfirmModalProps);
    }

    const renewAmlDepositCheck = (deposit:DepositDTO) => {
      loader.value?.show()
      confirmModal.value?.show({
        title: helper.trans('labels.renew_deposit_confirm'),
        okTitle: null,
        cancelTitle: null,
        onOkClick: async () => {
          try {
            await api.call.deposits.renewAMLDepositCheck(deposit.id);
          } finally {
            load()
          }
        }
      } as ConfirmModalProps);
    }

    const exportData = async () => {
      try {
        loader.value?.show()
        const params: any = {}
        
        if (state.requestDTO.statuses && state.requestDTO.statuses.length > 0) {
          params.statuses = state.requestDTO.statuses
        }
        
        if (state.requestDTO.account) {
          if (state.accountType === 'merchant') {
            params.merchantId = state.requestDTO.account.id
          } else {
            params.accountId = state.requestDTO.account.id
          }
        } else if (state.requestDTO.accountId) {
          params.accountId = state.requestDTO.accountId
        } else if (state.requestDTO.merchantId) {
          params.merchantId = state.requestDTO.merchantId
        }

        const blob = await deposits.export(params)
        const filename = `deposits_${new Date().toISOString().split('T')[0]}.xlsx`
        helper.downloadBlob(blob, filename)
      } catch (error) {
        notification.notify({
          title: 'Ошибка экспорта',
          text: 'Не удалось экспортировать данные',
          type: 'error'
        })
      } finally {
        loader.value?.hide()
      }
    }

    onMounted(() => {
      load();
    });

    const labelFor = (type: string, opt: TraderAccountDTO|UserAccountDTO|MerchantStoreAccountDTO|MerchantDTO) => {
      if (type === 'store') {
        const storeAccount = opt as MerchantStoreAccountDTO
        return `${storeAccount.user.name} (${storeAccount.user.email}) - ${storeAccount.storeName}`
      }

      if (type === 'merchant') {
        const merchant = opt as MerchantDTO
        return `${merchant.name} (${merchant.email})`
      }

      const account = opt as TraderAccountDTO|UserAccountDTO
      return `${account.user.name} (${account.user.email})`
    }

    const toggleType = () => {
      const index = state.accountType ? types.indexOf(state.accountType) : 0;
      let newValue = types[index + 1];
      state.accountType = newValue ?? types[0]
      state.accounts = []
      state.requestDTO.account = null;
      state.requestDTO.accountId = null
      state.requestDTO.merchantId = null
      if (state.accountType === 'system') {
        state.requestDTO.accountId = '00000000-0000-0000-0000-000000000000';
      } else if (state.accountType === null) {
        state.requestDTO.accountId = null
      }
    }

    const clearType = () => {
      state.accountType = null
      state.accounts = []
      state.requestDTO.account = null;
      state.requestDTO.accountId = null
      state.requestDTO.merchantId = null
    }

    const asyncFindAccounts = debounce(async (query) => {
      state.isLoading = true
      switch (state.accountType) {
        case 'trader':
          state.accounts = (await api.traderAccounts({limit: 100, offset: 0} as PaginationDTO, {query: query})).items;
          break;
        case 'teamlead':
          state.accounts = (await api.userAccounts({limit: 100, offset: 0} as PaginationDTO, {query: query, userRole: UserRole.TRADER_TEAM_LEAD})).items;
          break;
        case 'referral':
          state.accounts = (await api.userAccounts({limit: 100, offset: 0} as PaginationDTO, {query: query, userRole: UserRole.REFERRAL})).items;
          break;
        case 'store':
          state.accounts = (await api.merchantStoreAccounts({limit: 100, offset: 0} as PaginationDTO, {query: query})).items;
          break;
        case 'merchant':
          state.accounts = (await api.merchants({limit: 100, offset: 0} as PaginationDTO, {query: query})).items;
          break;
      }
      state.isLoading = false
    }, 500);

    return {
      ...toRefs(state),
      user: computed(() => store.getters.getUser),
      isAdmin: computed(() => store.getters.isAdmin),
      isOperator: computed(() => store.getters.isOperator),
      labelFor,
      toggleType,
      clearType,
      asyncFindAccounts,
      applyFilters,
      clearFilters,
      loader,
      dateHelper,
      numberFormatter,
      confirmModal,
      searchDepositModal,
      helper,
      load,
      store,
      UserRole,
      UserPermission,
      DepositStatus,
      returnDeposit,
      processDeposit,
      renewAmlDepositCheck,
      exportData
    }
  }
})
</script>
